import { c as _c } from "react/compiler-runtime";
import { getOrgArtifactsOptions } from '@onefootprint/fetch-dashboard';
import { useQuery } from '@tanstack/react-query';

// TODO: paginate — currently capped at the first page (pageSize=100).
// Add infinite scroll once a workflow can plausibly exceed this.
const useArtifacts = investigationId => {
  const $ = _c(5);
  let t0;
  if ($[0] !== investigationId) {
    t0 = getOrgArtifactsOptions({
      query: {
        investigationId,
        pageSize: 100
      }
    });
    $[0] = investigationId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = !!investigationId;
  let t2;
  if ($[2] !== t0 || $[3] !== t1) {
    t2 = {
      ...t0,
      enabled: t1,
      select: _temp
    };
    $[2] = t0;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return useQuery(t2);
};
export default useArtifacts;
function _temp(data) {
  return data.data;
}